import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';

import { AiTestingStartedTransientNotificationModel } from '../models/ai-testing-started-transient-notification-model';

@Component({
  selector: 'cai-ai-testing-started-transient-notification',
  templateUrl: './ai-testing-started-transient-notification.component.html',
  styleUrls: ['./ai-testing-started-transient-notification.component.scss'],
  standalone: false,
})
@NotificationType('AiTestingStartedTransientNotification')
export class AiTestingStartedTransientNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    try {
      this.notification = JSON.parse(data.payload);
    } catch {
      this.notification = null;
    }
  }

  notification: AiTestingStartedTransientNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
  ) {}

  showNotification(notification: NotificationModel) {
    try {
      this.notification = JSON.parse(notification.payload);
    } catch {
      return;
    }

    if (!this.notification) {
      return;
    }

    this.toasterService.info(
      this.localizationService.instant(
        'AiTesting::TestRunStartedWarning',
        this.notification.projectName,
        this.notification.name,
      ),
      null,
      { sticky: true },
    );
  }

  public getMessage(): string {
    if (!this.notification) {
      return '';
    }

    return this.localizationService.instant(
      'AiTesting::TestRunStartedWarning',
      this.notification.projectName,
      this.notification.name,
    );
  }
}
